<template>
  <div class="main-content-container container-fluid px-4" style="margin-top:-55px">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">User Setup</h3>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">UserSetup Add</h6>

        <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form>
                <d-form-row>
                  <!-- Email -->

                  <d-col md="5" class="form-group row">
                    <label class="col-md-5 col-form-label">UserName</label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control required-field"
                        v-model="Usersetup.DataModel.Data.UserName"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>

                  <d-col md="5" class="form-group row" style="margin-left:20px">
                    <!-- <label class="col-md-5 col-form-label">Password</label> -->
                    <!-- <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control required-field"
                        v-model="Usersetup.DataModel.Data.Usersetup.Amount"
                        autocomplete="off"
                      />
                    </div>-->
                  </d-col>
                  <d-col md="5" class="form-group row">
                    <label class="col-md-5 col-form-label">Password</label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control required-field"
                        v-model="Usersetup.DataModel.Data.Password"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>

                  <!-- <d-col md="5" class="form-group row" style="margin-left:20px">
                    <label class="col-md-5 col-form-label">Date</label>
                    <div class="col-md-7">
                      <input
                        type="date"
                        class="form-control required-field"
                        v-model="Usersetup.DataModel.Data.Usersetup.Date"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>-->
                </d-form-row>

                <d-form-row>
                  <!-- Email -->

                  <d-col md="5" class="form-group row">
                    <label class="col-md-5 col-form-label">ConfirmPassword</label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control required-field"
                        v-model="Usersetup.DataModel.Data.ConfirmPassword"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>

                  <!-- <d-col md="5" class="form-group row" style="margin-left:20px">
                    <label class="col-md-5 col-form-label">Amount</label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control required-field"
                        v-model="Usersetup.DataModel.Data.Usersetup.Amount"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>-->
                </d-form-row>
                <br />

                <div class style="text-align:center">
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="SubmitUsersetup"
                    style="margin-right:10px"
                  >Submit</d-button>
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="ClearUsersetup"
                  >Cancel</d-button>
                </div>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
  import Utilities from "@/Utilities/Utilities";
  import axios from "axios";
// import VueToast from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-default.css";
// Vue.use(VueToast);

export default {
  name: "Usersetup",
  data() {
    return {
      Usersetup: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            // User: {
            Id: 0,
            Username: null,
            Password: null,
            ConfirmPassword: null,
          },
          UIData: {},
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0,
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0,
          },
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "", // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],
        Masters: {
          UsersetupList: [],
        },
        Modal: {},
        CharRestrict: {},
      },
    };
  },
  mounted() {
    this.ListUsersetup();
  },
  methods: {
    Select() {
      console.log(this.Usersetup.DataModel.Data);
    },

    SubmitUsersetup() {
      let vm = this;
      
      this.Usersetup.DataModel.Data.InvestorId = 1;
      this.Usersetup.DataModel.Data.CRUD = "Create";

      var dataString = JSON.stringify(this.Usersetup.DataModel.Data);

      axios
        .post(
          "APIScript/PHP/APIService/UserSetup/UserSetupService.php",
          dataString
        )
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.$toaster.success("Save Successfully.");
            Utilities.gotoRoute(vm, "/user-setup");
            console.log(response.data);
          } else {
            if (
              !Utilities.IsNotNullOrEmptyOrUndefined(
                vm.Usersetup.DataModel.Data.Username
              ) ||
              !Utilities.IsNotNullOrEmptyOrUndefined(
                vm.Usersetup.DataModel.Data.Password
              )
            ) {
              console.log(response.data.ErrorInfo);
              vm.$swal.fire(
                "Information missing",
                "Please provid Mobile No, Date and Amount ",
                "error"
              );
            } else {
              console.log(response.data.ErrorInfo);
              vm.$swal.fire(
                "Oops...",
                "Incorrect Mobile No, Date or Amount !",
                "error"
              );
            }
          }
        })
        .catch(function (response) {
          console.log(response);
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
     
    },

    ClearUsersetup() {
      (this.Usersetup.DataModel.Data.Username = null),
        (this.Usersetup.DataModel.Data.Password = null),
        (this.Usersetup.DataModel.Data.ConfirmPassword = null);
    },

    ListUsersetup() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Usersetup.DataModel.Data.Token = Token;
      this.Usersetup.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Usersetup.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/UserSetup/UserSetupService.php",
          dataString
        )
        .then(function (response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.Usersetup.Masters.UsersetupList = response.data.Result;
            console.log(vm.Usersetup.Masters.UsersetupList);
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function (response) {
          console.log(response.data.ErrorInfo);
        });
    },
    SelectMobileNumber() {
      //  if (selected != undefined) {
      //             if (selected.originalObject.Id != undefined) {
      //                 this.Usersetup.DataModel.Data.Registration = selected.originalObject;
      //             }
      //              else {
      //                 var count = 0;
      //                 forEach(this.Usersetup.Masters.UsersetupList, function (value, key) {
      //                     if (value.ContactNumber == selected.originalObject) {
      //                         count++;
      //                         this.Usersetup.DataModel.Data = value;
      //                     }
      //                 });

      //             }
      //         }

      Object.entries(this.Usersetup.Masters.UsersetupList).forEach(
        ([key, val]) => {
          if (val.ContactNumber == this.Usersetup.DataModel.Data.Username) {
            this.Usersetup.DataModel.Data.Username = val;
          }

          this.Usersetup.DataModel.Data.Username = Utilities.selectFromList(
            this.Usersetup.DataModel.Data.Username,
            this.Usersetup.Masters.UsersetupList,
            "ContactNumber"
          );
        }
      );
    },
  },
};
</script>
